(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogDetailController', CompanyPaymentLogDetailController);

    CompanyPaymentLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyPaymentLog', 'AccountClearingRequest', 'Company'];

    function CompanyPaymentLogDetailController($scope, $rootScope, $stateParams, entity, CompanyPaymentLog, AccountClearingRequest, Company) {
        var vm = this;

        vm.companyPaymentLog = entity;

        var unsubscribe = $rootScope.$on('tikonApp:companyPaymentLogUpdate', function (event, result) {
            vm.companyPaymentLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
